<template>
    <div :class="['empty-state', 'is-' + variant]">
        <i :class="['far', icon, 'fa-fw', 'mr-3', 'empty-icon']"></i>
        <div class="empty-body">
            <div class="empty-title" v-if="title">{{ title }}</div>
            <div class="empty-text" v-if="text">{{ text }}</div>
            <div class="empty-actions" v-if="$slots.default"><slot/></div>
        </div>
    </div>
</template>

<script>
    // Two flavours: `canvas` = white text straight on the blue gradient
    // (the Enrollments/Registrations "nothing here yet" line), `card` =
    // grey text inside a white ui-card.
    export default {
        name: "EmptyState",
        props: {
            icon: {type: String, default: 'fa-info-circle'},
            title: {type: String, default: null},
            text: {type: String, default: null},
            variant: {type: String, default: 'canvas', validator: v => ['canvas', 'card'].includes(v)},
        }
    };
</script>

<style lang="scss" scoped>
    .empty-state {
        display: flex;
        align-items: flex-start;

        .empty-icon {
            margin-top: 0.15rem;
        }

        .empty-title {
            font-weight: 600;
        }

        .empty-text {
            font-size: 0.9rem;
            margin-top: 0.15rem;
        }

        .empty-actions {
            margin-top: 0.75rem;
        }

        &.is-canvas {
            color: white;
        }

        &.is-card {
            color: #6b6b6b;

            .empty-icon {
                color: #336699;
            }
        }
    }
</style>
